<h5>Naturezas Jurídicas Aceitas</h5>

<section class="pesquisa">
  <div class="container">
    <form class="mt-3 mx-auto">
      <div class="mb-3 row">
        <div class="col">
          <h3>Pesquisa</h3>
        </div>
        <div class="col-auto">
          <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
        </div>
        <div class="col-auto" *ngIf="ideTranche == null; else podePesquisar">
          <button disabled type="button" class="btn btn-success no-margin">
            Repasse</button>
        </div>
        <ng-template #podePesquisar>
          <div class="col-auto">
            <button type="button" class="btn btn-success no-margin" (click)="buscarTodosRepasses()">
              Repasse</button>
          </div>
        </ng-template>
        <div class="col-auto" *ngIf="ideTranche == null; else podePesquisar2">
          <button disabled type="button" class="btn btn-success no-margin">
            Crédito Livre</button>
        </div>
        <ng-template #podePesquisar2>
          <div class="col-auto">
            <button type="button" class="btn btn-success no-margin" (click)="buscarTodosCreditoLivre()">
              Crédito Livre</button>
          </div>
        </ng-template>
      </div>
    </form>

    <div class="bn-form-group row">
      <div class="col-md-5">
        <label for="tranche">Cesta: </label>
        <select id="tranche" class="form-select" [(ngModel)]="ideTranche">
          <option [ngValue]=null></option>
          <option [ngValue]="tranche.id" *ngFor="let tranche of tranches">
            {{tranche.numeroTranche}} ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})</option>
        </select>
      </div>
    </div>
  </div>
</section>

<app-credito-livre-listagem
[creditoLivre]="creditoLivre"
[ideTranche]="ideTranche"
[permissaoGestorEnvio]="permissaoGestorEnvio"
 *ngIf="pesquisadoCreditoLivre">
</app-credito-livre-listagem>

<app-repasse-listagem
 [repasseBndes]="repasseBndes"
 [ideTranche]="ideTranche"
 [permissaoGestorEnvio]="permissaoGestorEnvio"
 *ngIf="pesquisadoRepasse">
</app-repasse-listagem>
